import _ from 'underscore';

import { EVENT_ID_FIELD, EVENT_PARAMS_FIELD, PARAM_EVENT_ID_FIELD, PARAM_ID_FIELD } from '../utils/constants';
const DEFAULT_LOCATION_REDUCER = {
  locations: [],
  params: new Map(),
  lastFetchDate: undefined
};

const locationReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_GPS_JSON":{
       return { gps: [...action.data.data], ...state};
    }
    case "FETCH_LAST_LOCATION": {
      // console.log('[FETCH_LAST_LOCATION]', action.data);
      return {...state, locations: [action.data]}
    }
    case "FETCH_LOCATIONS": {
      // if (action.data.items.length === 0)
      //   return state;
      //const lastFetchDate = action.data.items.length === 0? state.lastFetchDate : action.data.items[0][EVENT_GEN_DATE_FIELD];
      // if(!state.gps){
      //   return { locations: [...action.data.items], ...state };  
      // }
      return { ...state, locations: [...action.data.items] };
    }

    case "FETCH_LOCATION_PARAMS": {
      state.params.set(action.data[EVENT_ID_FIELD], action.data);
      return { ...state };
    }

    case "FETCH_PHOTOS":
    case "FETCH_IMPORTANT_PLACES": {
      if (action.data.items.length === 0)
        return state;
      let added = false;
      _.each(action.data.items, item => {
        const locId = item[PARAM_EVENT_ID_FIELD];
        let newLocationParams = [item];
        if (state.params.has(locId)) {
          if (!_.contains(_.map(state.params.get(locId), p => p[PARAM_ID_FIELD]), item[PARAM_ID_FIELD])) {
            newLocationParams = [...newLocationParams, ...state.params.get(locId)];
            state.params.set(locId, newLocationParams);
            added = true;
          }
        } else {
          state.params.set(locId, newLocationParams);
        }
      });
      return added ? { ...state } : state;
    }
    default:
      return state;
  }
}

const getFullLocation = (locationReducer, location) => {
  const params = locationReducer.params.get(location[EVENT_ID_FIELD]);
  return { ...location, [EVENT_PARAMS_FIELD]: params };
};

const getFullLocations = locationReducer => {
  return _.map(locationReducer.locations, l => getFullLocation(locationReducer, l));
};

export { locationReducer as default, DEFAULT_LOCATION_REDUCER, getFullLocation, getFullLocations }